import CaretDownIcon from "public/next-public/common/icons/caret-solid-down.svg";
import React, { ReactNode, useState } from "react";
import styles from "./vendorOptions.module.scss";

function VendorOptions({ children, totalVendorOptions, ref, expanded, onExpandedChange }: VendorPickerProps) {
  const [internalExpanded, setInternalExpanded] = useState(false);
  const isExpanded = expanded ?? internalExpanded;

  const toggleExpanded = () => {
    if (onExpandedChange) {
      onExpandedChange(!isExpanded);
    } else {
      setInternalExpanded((prev) => !prev);
    }
  };

  return (
    <section ref={ref} id="vendor-options" className={styles.vendorOptions}>
      <h2 className={styles.vendorOptionsTitle}>Vendor Options</h2>
      {totalVendorOptions > 1 && (
        <div
          className={styles.otherVendorOffers}
          role="button"
          tabIndex={0}
          aria-expanded={isExpanded}
          onClick={toggleExpanded}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              toggleExpanded();
            }
          }}
        >
          <span className={styles.otherVendorOffersTitle}>
            Other Vendor Offers ({totalVendorOptions > 0 ? totalVendorOptions - 1 : 0})
          </span>
          <CaretDownIcon
            className={`${styles.otherVendorOffersToggle} ${isExpanded ? styles.upsideDown : ""}`}
            width={16}
            height={16}
            aria-hidden
          />
        </div>
      )}

      <div className={styles.vendorHeader}>
        <div className={styles.vendorHeaderInfo}>Vendor</div>
        <div className={styles.vendorHeaderPricing}>Price + Shipping</div>
        <div className={styles.vendorHeaderTotal}>Total</div>
        <div className={styles.vendorHeaderAddToCart}></div>
      </div>
      <div className={`${styles.vendorBody} ${isExpanded ? "" : styles.hideVendorBody}`}>{children}</div>
    </section>
  );
}

type VendorPickerProps = {
  children?: ReactNode; // Define children prop here
  totalVendorOptions: number;
  ref?: React.MutableRefObject<HTMLElement>;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
};
export default VendorOptions;
